export const spinAnimation = {
  animation: "spin 1s linear infinite",
  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
};

export const blinkAnimation = {
  animation: "blink 1s ease infinite",
  "@keyframes blink": {
    "0%, 100%": { opacity: 0 },
    "50%": { opacity: 1 },
  },
};
